import script from "./protocol.vue?vue&type=script&setup=true&lang=js"
export * from "./protocol.vue?vue&type=script&setup=true&lang=js"

import "./protocol.vue?vue&type=style&index=0&id=762ef35f&lang=scss"

const __exports__ = script;

export default __exports__